import { Container, Grid, Stack, useBreakpointValue } from '@chakra-ui/react';
import { FC, ReactNode, useLayoutEffect, useRef } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';

import { Navbar } from './navigation/Navbar';
import { Sidebar } from './navigation/Sidebar';

type MainLayoutProps = {
  permissions: Array<string> | undefined;
  children?: ReactNode;
  isAuthenticating?: boolean;
  pusher?: any;
};

export const MainLayout: FC<MainLayoutProps> = (prop) => {
  const { isAuthenticating = false, pusher, permissions } = prop;
  const isDesktop = useBreakpointValue({ base: false, lg: true }, { ssr: false });
  const urlParams = useParams();
  const { pathname } = useLocation();
  const contentRef = useRef<HTMLDivElement>(null);

  // The layout stays mounted across navigations, so the content area would otherwise keep the previous page's scroll position
  useLayoutEffect(() => {
    contentRef.current?.scrollTo(0, 0);
  }, [pathname]);

  const hidePaddingSpacing =
    urlParams['*']?.includes('workshop-verification-request/') ||
    urlParams['*']?.includes('b2c-verification-request/') ||
    urlParams['*']?.includes('service-record/') ||
    urlParams['*']?.includes('service-history-request/') ||
    urlParams['*']?.includes('workshop-update-request/') ||
    urlParams['*']?.includes('account/') ||
    urlParams['*']?.includes('b2c-service-history-request/');

  return (
    <Grid
      templateColumns={{
        base: 'var(--chakra-sizes-full)',
        lg: 'auto 1fr',
      }}
      templateRows={{
        base: 'auto 1fr',
        lg: 'auto',
      }}
      as="section"
      bg="bg-canvas"
      overflowY="hidden"
      h="100vh"
    >
      {pusher}
      {isDesktop ? (
        <Sidebar permissions={permissions} isLoading={isAuthenticating} />
      ) : (
        <Navbar permissions={permissions} isLoading={isAuthenticating} />
      )}

      <Container ref={contentRef} px={0} flex="1" maxW="unset" textAlign="left" pos={'relative'} overflow={'auto'}>
        {hidePaddingSpacing ? (
          <Outlet key={pathname} />
        ) : (
          <Container pt={{ base: '8', lg: '8' }} pb="16" maxW={'unset'}>
            <Stack spacing={{ base: '8', lg: '6' }}>
              <Outlet key={pathname} />
            </Stack>
          </Container>
        )}
      </Container>
    </Grid>
  );
};
